module.exports = __webpack_public_path__ + "static/media/rmr_live_logo_v2.db12bd57.png";